(function () {
  if (window.__mpnV8Fix) return; window.__mpnV8Fix = true;
  var lang = (document.documentElement.lang || 'fr').slice(0, 2);
  var QUIT = { fr: 'Quitter la recherche', en: 'Exit search', de: 'Suche verlassen' }[lang] || 'Quitter la recherche';
  var PREV = { fr: 'Précédent', en: 'Previous', de: 'Zurück' }[lang] || 'Précédent';
  var NEXT = { fr: 'Suivant', en: 'Next', de: 'Weiter' }[lang] || 'Suivant';
  var desk = function () { return window.matchMedia('(min-width: 990px)').matches; };

  function header() {
    return document.querySelector('.shopify-section-header-sticky') || document.querySelector('[id^="shopify-section-"][id$="header"]') || document.querySelector('.section-header') || document.querySelector('header');
  }
  function setHdr(so) {
    if (!desk()) { so.style.removeProperty('--mpn-hdr'); return; }
    var h = header(), b = 0;
    if (h) {
      h.classList.remove('shopify-section-header-hidden', 'animate');
      b = Math.max(0, Math.round(h.getBoundingClientRect().bottom));
    }
    /* bas du bloc d'en-tete complet (barre verte + menu noir), meme si le menu etait en train de se replier */
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (g) {
      var r = g.getBoundingClientRect();
      if (r.height > 0 && r.top < window.innerHeight * 0.3) b = Math.max(b, Math.round(r.bottom));
    });
    so.style.setProperty('--mpn-hdr', Math.min(b, Math.round(window.innerHeight * 0.3)) + 'px');
  }
  function arrows(so) {
    so.querySelectorAll('.mpn-so__cards, .mpn-so__vcards').forEach(function (list) {
      var sec = list.parentElement;
      if (!sec) return;
      if (!list.__mpnArr) {
        list.__mpnArr = true;
        var mk = function (dir) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'mpn-so__arr mpn-so__arr--' + (dir < 0 ? 'prev' : 'next');
          b.setAttribute('aria-label', dir < 0 ? PREV : NEXT);
          b.innerHTML = '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="' + (dir < 0 ? 'M10 3 5 8l5 5' : 'm6 3 5 5-5 5') + '" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
          b.addEventListener('click', function () { list.scrollBy({ left: dir * list.clientWidth * 0.8, behavior: 'smooth' }); });
          sec.appendChild(b);
          return b;
        };
        list.__prev = mk(-1); list.__next = mk(1);
        list.addEventListener('scroll', function () { upd(list); }, { passive: true });
      }
      upd(list);
    });
  }
  function upd(list) {
    if (!list.__prev) return;
    var top = list.offsetTop + list.offsetHeight / 2 - 20;
    if (list.querySelector('img')) {
      var im = list.querySelector('img');
      top = list.offsetTop + Math.min(list.offsetHeight, im.offsetHeight || list.offsetHeight) / 2 - 20;
    }
    list.__prev.style.top = top + 'px'; list.__next.style.top = top + 'px';
    var max = list.scrollWidth - list.clientWidth;
    list.__prev.hidden = !(max > 4 && list.scrollLeft > 4);
    list.__next.hidden = !(max > 4 && list.scrollLeft < max - 4);
  }
  function init() {
    var so = document.getElementById('MpnSearchOverlay');
    if (!so || so.__mpnV8) return;
    so.__mpnV8 = true;
    if (lang === 'fr') so.querySelectorAll('.mpn-so__sec--viewed .mpn-so__h').forEach(function (h) { h.textContent = 'Récemment consultés'; });
    var CLR = { fr: 'Effacer l’historique', en: 'Clear history', de: 'Verlauf löschen' }[lang];
    if (CLR) so.querySelectorAll('[data-mpn-so-recent-clear]').forEach(function (c) { c.textContent = CLR; });
    var back = so.querySelector('.mpn-so__back');
    if (back && !back.querySelector('.mpn-so__back-t')) {
      var t = document.createElement('span');
      t.className = 'mpn-so__back-t';
      t.textContent = QUIT;
      back.appendChild(t);
    }
    so.addEventListener('click', function (e) {
      if (e.target === so && desk()) {
        var c = so.querySelector('[data-mpn-so-close]');
        if (c) c.click();
      }
    });
    var refresh = function () { if (so.classList.contains('is-open')) { setHdr(so); arrows(so); } };
    new MutationObserver(function () { setTimeout(refresh, 30); }).observe(so, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    window.addEventListener('resize', refresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setTimeout(init, 1500);

  /* Fenetres "Comparer" : ouvertes sous l'en-tete sur ordinateur */
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-mpn-decl-open]')) return;
    var h = header(), b = 0;
    if (h && window.matchMedia('(min-width: 750px)').matches) {
      h.classList.remove('shopify-section-header-hidden', 'animate');
      b = Math.max(0, Math.round(h.getBoundingClientRect().bottom));
    }
    document.documentElement.style.setProperty('--mpn-hdr-root', b + 'px');
  }, true);

  /* Feuilles de pierre : prix a la piece en grand, prix au m2 en petit */
  function feuille() {
    if (!/\/products\/feuille-de-pierre/.test(location.pathname)) return;
    document.querySelectorAll('[id^="variant-price-summary-"]').forEach(function (b) {
      var mp = b.querySelector('[data-main-price]'), mu = b.querySelector('[data-main-unit]');
      var pp = b.querySelector('[data-package-price]'), pu = b.querySelector('[data-package-unit]');
      if (!mp || !mu || !pp || !pu || !pp.textContent.trim()) return;
      if (!/m²|m2|sqm/.test(mu.textContent)) return;
      var a = mp.textContent, u = mu.textContent;
      mp.textContent = pp.textContent; mu.textContent = pu.textContent;
      pp.textContent = a; pu.textContent = u;
      var mc = b.querySelector('[data-main-compare-price]'), pc = b.querySelector('[data-package-compare-price]');
      if (mc && pc) { var t = mc.textContent, d = mc.style.display; mc.textContent = pc.textContent; mc.style.display = pc.style.display; pc.textContent = t; pc.style.display = d; }
      var line = b.querySelector('[data-package-price-line]'); if (line) line.hidden = false;
      if (!b.__mpnFeuille && window.MutationObserver) {
        b.__mpnFeuille = true;
        new MutationObserver(function () { setTimeout(feuille, 20); }).observe(b, { childList: true, characterData: true, subtree: true });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', feuille); else feuille();
  setTimeout(feuille, 400); setTimeout(feuille, 1200);

  /* Barre verte du haut sur ordinateur : les messages defilent */
  function annRotate() {
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    var s = document.querySelector('.announcement-bar-section .slider');
    if (!s || s.__mpnRot) return;
    var slides = s.querySelectorAll('.slider__slide');
    if (slides.length < 2) return;
    s.__mpnRot = true;
    var last = -1, still = 0;
    setInterval(function () {
      if (document.hidden || !s.clientWidth) return;
      var cur = Math.round(s.scrollLeft / s.clientWidth);
      if (cur === last) still++; else still = 0;
      last = cur;
      if (still < 1) return;
      var next = (cur + 1) % slides.length;
      s.scrollTo({ left: next * s.clientWidth, behavior: 'smooth' });
      still = 0;
    }, 2500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', annRotate); else annRotate();
  setTimeout(annRotate, 2000);
  /* Barre flottante "Ajouter au panier" : seulement une fois le vrai bouton depasse */
  function stickyAtc() {
    var bars = document.querySelectorAll('.sticky-container');
    if (!bars.length) return;
    var btn = null;
    document.querySelectorAll('.product .product-form__buttons, .product .product-form__submit, .product quantity-calculator, .product product-form, .product .product-form').forEach(function (el) {
      if (!btn && !el.closest('.sticky-container, sticky-add') && el.offsetHeight > 0) btn = el;
    });
    var past = btn ? btn.getBoundingClientRect().bottom < 0 : window.scrollY > 700;
    bars.forEach(function (b) { b.classList.toggle('mpn-past', past); });
  }
  window.addEventListener('scroll', stickyAtc, { passive: true });
  window.addEventListener('resize', stickyAtc);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stickyAtc); else stickyAtc();

  /* Videos de la galerie produit : barre de lecture (duree, pause) */
  function videoCtl() {
    document.querySelectorAll('.product__media-list video, .product-media-modal video').forEach(function (v) {
      if (v.__mpnCtl) return;
      v.__mpnCtl = true;
      v.controls = true;
      v.setAttribute('controls', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('controlsList', 'nodownload nofullscreen noremoteplayback');
      v.disablePictureInPicture = true;
      v.setAttribute('disablepictureinpicture', '');
      /* Pas de plein ecran natif (double-clic) : le grand format passe par le bouton Agrandir en haut a droite */
      v.addEventListener('dblclick', function (e) { e.preventDefault(); e.stopPropagation(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', videoCtl); else videoCtl();
  setInterval(videoCtl, 1500);

  /* Bouton "Agrandir" sur les videos de la galerie : ouvre la visionneuse plein ecran sur la video */
  var ZOOM = { fr: 'Agrandir la vidéo', en: 'Enlarge video', de: 'Video vergrößern' }[lang] || 'Agrandir la vidéo';
  function vidZoom() {
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    document.querySelectorAll('.product__media-list .product-media-container.media-type-video').forEach(function (c) {
      if (c.querySelector('.mpn-vid-zoom')) return;
      var opener = c.querySelector('modal-opener[data-modal]'), toggle = c.querySelector('.product__media-toggle[data-media-id]');
      if (!opener || !toggle) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mpn-vid-zoom'; b.setAttribute('aria-label', ZOOM); b.title = ZOOM;
      b.innerHTML = '<svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true"><path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var m = document.querySelector(opener.getAttribute('data-modal'));
        if (!m || !m.show) return;
        c.querySelectorAll('video').forEach(function (v) { if (v.pause) v.pause(); });
        m.show(toggle);
      });
      c.appendChild(b);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vidZoom); else vidZoom();
  setTimeout(vidZoom, 1500);

  /* Fiche produit, ordinateur : galerie et bloc achat restent visibles au defilement.
     Plus hauts que l'ecran : ils defilent jusqu'a leur bas, puis restent cales en bas de l'ecran. */
  function stickyCols() {
    var root = document.querySelector('[id$="__main"] .product.grid--2-col-tablet');
    if (!root) return;
    if (!window.matchMedia('(min-width: 990px)').matches) { root.style.removeProperty('--mpn-info-top'); root.style.removeProperty('--mpn-gal-top'); return; }
    var h = header(), base = 26;
    if (h) {
      var cs = getComputedStyle(h);
      if (cs.position === 'sticky' || cs.position === 'fixed') base = Math.round(h.getBoundingClientRect().height) + 26;
    }
    var vh = window.innerHeight;
    var info = root.querySelector('.product__info-container'), gal = root.querySelector('.product__media-wrapper media-gallery');
    if (info) root.style.setProperty('--mpn-info-top', Math.min(base, vh - info.offsetHeight - 24) + 'px');
    if (gal) root.style.setProperty('--mpn-gal-top', Math.min(base, vh - gal.offsetHeight - 24) + 'px');
  }
  var scRaf = 0;
  function stickyColsSoon() { if (scRaf) return; scRaf = requestAnimationFrame(function () { scRaf = 0; stickyCols(); }); }
  window.addEventListener('resize', stickyColsSoon);
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(stickyColsSoon);
    var watch = function () {
      var r = document.querySelector('[id$="__main"] .product.grid--2-col-tablet');
      if (!r || r.__mpnRO) return; r.__mpnRO = true;
      var i = r.querySelector('.product__info-container'), g = r.querySelector('.product__media-wrapper media-gallery');
      if (i) ro.observe(i); if (g) ro.observe(g);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stickyCols); else stickyCols();
  window.addEventListener('load', stickyCols);

  /* Produit epuise (ordinateur) : barre flottante = bouton "Prevenez-moi" de l'appli */
  var ATC_RE = /ajouter au panier|add to cart|in den warenkorb/i;
  var SOLD_RE = /épuisé|epuise|sold out|ausverkauft|indisponible|unavailable|nicht verf/i;
  var BIS_RE = /prévenez|prevenez|m'alerter|me prévenir|notify|benachrichtig|quand disponible|when available|wieder verf/i;
  function findBis() {
    var scope = document.querySelector('[id$="__main"] .product__info-container') || document.querySelector('.product__info-container');
    if (!scope) return null;
    var found = null;
    scope.querySelectorAll('button, a, input[type=button], input[type=submit], [role=button]').forEach(function (b) {
      if (found || b.closest('.sticky-container, sticky-add')) return;
      var t = (b.textContent || b.value || '').replace(/\s+/g, ' ').trim();
      var r = b.getBoundingClientRect();
      if (t && BIS_RE.test(t) && r.width > 20 && r.height > 16 && getComputedStyle(b).visibility !== 'hidden') found = b;
    });
    return found;
  }
  function deskBis() {
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    document.querySelectorAll('.sticky-container').forEach(function (bar) {
      var btn = bar.querySelector('[data-mpn-dbis]') || bar.querySelector('button[type=submit], button[name=add], .product-form__submit');
      if (!btn) return;
      var label = btn.querySelector('span') || btn;
      var txt = (btn.textContent || '').replace(/\s+/g, ' ').trim();
      if (btn.hasAttribute('data-mpn-dbis')) {
        if (ATC_RE.test(txt) && !btn.disabled) {
          btn.removeAttribute('data-mpn-dbis');
          ['background', 'color', 'border-color'].forEach(function (p) { btn.style.removeProperty(p); });
          if (label !== btn) label.style.removeProperty('color');
          return;
        }
      } else if (!(btn.disabled || SOLD_RE.test(txt))) return;
      var bis = findBis();
      if (!bis) return;
      var bt = (bis.textContent || bis.value || '').replace(/\s+/g, ' ').trim();
      btn.setAttribute('data-mpn-dbis', '1');
      if (btn.disabled) btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      if (label.textContent.trim() !== bt) label.textContent = bt;
      var cs = getComputedStyle(bis);
      btn.style.setProperty('background', cs.backgroundColor, 'important');
      btn.style.setProperty('color', cs.color, 'important');
      btn.style.setProperty('border-color', cs.borderColor, 'important');
      if (label !== btn) label.style.setProperty('color', cs.color, 'important');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.sticky-container [data-mpn-dbis]');
    if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var bis = findBis();
    if (!bis) return;
    bis.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { bis.click(); }, 450);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', deskBis); else deskBis();
  window.addEventListener('load', deskBis);
  setInterval(deskBis, 1200);

  /* Pastille d'etape "2" sur le libelle de quantite visible */
  function stepBadge() {
    var c = document.querySelector('[id$="__main"] .product__info-container') || document.querySelector('.product__info-container');
    if (!c) return;
    var fmt = c.querySelector('.mpn-fmt__step .mpn-step');
    if (!fmt || !fmt.offsetHeight) return;
    var q = null;
    c.querySelectorAll('.quantity__label').forEach(function (l) {
      if (!q && l.offsetHeight > 0 && !l.closest('pose-accessories, .pose-accessories, .sticky-container, sticky-add, .mpn-decl, .mpn-so')) q = l;
    });
    if (!q || q.querySelector('.mpn-step')) return;
    var sp = document.createElement('span');
    sp.className = 'mpn-step'; sp.setAttribute('aria-hidden', 'true');
    sp.textContent = String((parseInt(fmt.textContent, 10) || 1) + 1);
    q.insertBefore(sp, q.firstChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stepBadge); else stepBadge();
  window.addEventListener('load', stepBadge);
  setInterval(stepBadge, 1500);
})();
